module.exports = __webpack_public_path__ + "img/ico_badge02.d76aa151.svg";